import { render, staticRenderFns } from "./KisiForm.vue?vue&type=template&id=01765650&scoped=true"
import script from "./KisiForm.vue?vue&type=script&lang=ts"
export * from "./KisiForm.vue?vue&type=script&lang=ts"
import style0 from "./KisiForm.vue?vue&type=style&index=0&id=01765650&prod&scoped=true&lang=css"
import style1 from "./KisiForm.vue?vue&type=style&index=1&id=01765650&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01765650",
  null
  
)

export default component.exports